// extracted by mini-css-extract-plugin
module.exports = {"main":"ImagePage_main__1JfGo","btn-container":"ImagePage_btn-container__14J9H","container":"ImagePage_container__SY1kL"};